module.exports = __webpack_public_path__ + "img/mapna.3c6194b.webp";